// /* eslint-disable jsx-a11y/anchor-is-valid */
import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React, { useState } from 'react';
import { Button, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import validAllowedCharacters from '../../../constants/valid-character-password';
import { ActiveTrayFilterInitialState } from '../../../core/initialState/filter-initial-state';
import { IActiveTrayFilter } from '../../../models/IActiveTrayFilter';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import {
  ClearFilterIcon,
  CloseFilterIcon,
  FilterIcon,
} from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: IActiveTrayFilter;
  id: number;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  onModalClosed: () => void;
  isLoading: boolean;
  isDisable: boolean;
  isFilterCleared: boolean;
  isFilterApplied: boolean;
  setIsFilterApplied: (status: boolean) => void;
}
const FilterComponent = (props: IProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggle = (isOpen: boolean, resetForm: () => void) => {
    if(!isOpen){
      resetForm();
    }
    setShowDropdown(isOpen);
  };

  function getLocalISODate(isoDate: Date) {
    return (
      isoDate.getFullYear() +
      '-' +
      String(isoDate.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(isoDate.getDate()).padStart(2, '0') +
      'T' +
      String(isoDate.getHours()).padStart(2, '0') +
      ':' +
      String(isoDate.getMinutes()).padStart(2, '0') +
      ':' +
      String(isoDate.getSeconds()).padStart(2, '0')
    );
  }

  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        // validationSchema={FilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (
          values: IActiveTrayFilter,
          { resetForm, setFieldValue }
        ) => {
          if (values.CustomerDueDate) {
            values = {
              ...values,
              CustomerDueDate: `${getLocalISODate(
                new Date(values.CustomerDueDate)
              ).slice(0, 10)}`,
            };
          }

          if (values.PlanedDueDate) {
            values = {
              ...values,
              PlanedDueDate: `${getLocalISODate(
                new Date(values.PlanedDueDate)
              ).slice(0, 10)}`,
            };
          }

          if (values.ProcessDueDate) {
            values = {
              ...values,
              ProcessDueDate: `${getLocalISODate(
                new Date(values.ProcessDueDate)
              ).slice(0, 10)}`,
            };
          }

          props.submitHandler(values);
          setShowDropdown(false);
          props.setIsFilterApplied(true);
        }}
      >
        {({ dirty, resetForm, setFieldValue, values }) => {
          return (
            <Dropdown
              placement="bottom"
              className={`Filter-DID fiter-active-tray ${props.isDisable ? 'disabled-li' : ''}`}
              show={showDropdown}
              onToggle={(isOpen) => handleToggle(isOpen, resetForm)}
            >
              <Dropdown.Toggle
                className={`btn btn-light ${props.isFilterApplied ? 'btn-filter-disable' : 'btn-filter'}`}
                aria-expanded="false"
                title={formatMessage('filter')}
              >
                {/* <FilterIcon isDisable={props.isDisable} /> */}
                {!props.isFilterApplied ? (
                  <FilterIcon isDisable={props.isDisable} />
                ) : (
                  <ClearFilterIcon
                    onClick={(e) => {
                      // props.filterParmas(
                      //   { ...ActiveTrayFilterInitialState },
                      //   true
                      // );
                      resetForm();
                      setShowDropdown(!showDropdown);
                      // props.setIsFilterApplied(!props.isFilterApplied);
                    }}
                  />
                )}
              </Dropdown.Toggle>
              <FormikForm className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} />
                ) : null}
                <Dropdown.Menu className="filter-menu">
                  <Dropdown.ItemText className="p-0">
                    <Form.Group controlId="dateRange">
                      <div
                        className={`filter-header border-bottom p-3 px-4 ${props.isFilterCleared ? '' : ''}`}
                      >
                        <h4>
                          {formatMessage('filter')}
                          <a
                            className="clear-filter float-end"
                            onClick={() => {
                              resetForm();
                              setShowDropdown(false);
                            }}
                          >
                            <CloseFilterIcon/>
                          </a>
                        </h4>
                      </div>
                      <Row className="p-3 px-4">
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="tray_id"
                              htmlFor="TrayId"
                            />
                            <Field
                              data-testid="TrayId"
                              className="form-control"
                              name="TrayId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="order_id"
                              htmlFor="OrderId"
                            />
                            <Field
                              data-testid="OrderId"
                              className="form-control"
                              name="OrderId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="customer_due_date"
                              htmlFor="CustomerDueDate"
                            />
                            <Field
                              data-testid="CustomerDueDate"
                              className="form-control"
                              name="CustomerDueDate"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormDatePicker}
                              isClearable={values.CustomerDueDate}
                              // minDate={new Date()}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style col-form-label"
                              required={false}
                              label="process_due_date"
                              htmlFor="ProcessDueDate"
                            />
                            <Field
                              data-testid="ProcessDueDate"
                              className="form-control"
                              name="ProcessDueDate"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormDatePicker}
                              isClearable={values.ProcessDueDate}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style col-form-label"
                              required={false}
                              label="process_name"
                              htmlFor="ProcessName"
                            />
                            <Field
                              data-testid="ProcessName"
                              className="form-control"
                              name="ProcessName"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        {/* <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="planned_due_dates"
                              htmlFor="PlanedDueDate"
                            />
                            <Field
                              data-testid="PlanedDueDate"
                              className="form-control"
                              name="PlanedDueDate"
                              autoComplete="off"
                              placeholder=""
                              dateFormat={DateFormatForDatePickerJP}
                              as={FormikFormDatePicker}
                            />
                          </div>
                        </Col> */}
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="end_user_order_id"
                              htmlFor="EndUserOrderId"
                            />
                            <Field
                              data-testid="EndUserOrderId"
                              className="form-control"
                              name="EndUserOrderId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="end_user_name"
                              htmlFor="EndUserName"
                            />
                            <Field
                              data-testid="EndUserName"
                              className="form-control"
                              name="EndUserName"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="kishu"
                              htmlFor="Kishu"
                            />
                            <Field
                              data-testid="Kishu"
                              className="form-control"
                              name="Kishu"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>{' '}
                        {/* <Col md={3}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="customer_id"
                              htmlFor="CustomerId"
                            />
                            <Field
                              data-testid="CustomerId"
                              className="form-control"
                              name="CustomerId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col> */}
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="quantity"
                              htmlFor="Quantity"
                            />
                            <Field
                              data-testid="Quantity"
                              className="form-control"
                              name="Quantity"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="missing_parts"
                              htmlFor="MissingParts"
                            />
                            <Field
                              data-testid="MissingParts"
                              className="form-control"
                              name="MissingParts"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style col-form-label"
                              label="sub_contractor"
                            />
                            <Field
                              data-testid="testProcessName"
                              className="form-control"
                              name="SubContractor"
                              type="text"
                              placeholder=""
                              as={FormikFormInput}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="product_comment_1"
                              htmlFor="ProductComment1"
                            />
                            <Field
                              data-testid="ProductComment1"
                              className="form-control"
                              name="ProductComment1"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="product_comment_2"
                              htmlFor="ProductComment2"
                            />
                            <Field
                              data-testid="ProductComment2"
                              className="form-control"
                              name="ProductComment2"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="product_comment_3"
                              htmlFor="ProductComment3"
                            />
                            <Field
                              data-testid="ProductComment3"
                              className="form-control"
                              name="ProductComment3"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="product_comment_4"
                              htmlFor="ProductComment4"
                            />
                            <Field
                              data-testid="ProductComment4"
                              className="form-control"
                              name="ProductComment4"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="product_comment_5"
                              htmlFor="ProductComment5"
                            />
                            <Field
                              data-testid="ProductComment5"
                              className="form-control"
                              name="ProductComment5"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="product_comment_6"
                              htmlFor="ProductComment6"
                            />
                            <Field
                              data-testid="ProductComment4"
                              className="form-control"
                              name="ProductComment6"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Dropdown.ItemText>
                  <Dropdown.Divider className="mb-0" />
                  <div className="d-flex filter-btn p-3 px-4 justify-content-between align-items-center">
                <div style={{ visibility: props.isFilterCleared ? 'hidden' : 'visible' }}>
                    <Button
                        className="clear-filter float-end"
                        onClick={() => {
                          props.filterParmas(ActiveTrayFilterInitialState, true);
                          resetForm();
                          setShowDropdown(false);
                          props.setIsFilterApplied(false);
                        }}
                      >
                        {formatMessage('clear_all_filters')}
                       </Button>
                    </div>
                    <Button
                      variant="secondary"
                      type="submit"
                      className=""
                      disabled={(JSON.stringify(props.initialValues) === JSON.stringify(values)) || (!values.TrayId && !values.OrderId && !values.CustomerDueDate && !values.PlanedDueDate && !values.ProcessDueDate && !values.ProcessName && !values.EndUserOrderId && !values.EndUserName && !values.Kishu && !values.Quantity && !values.MissingParts && !values.SubContractor && !values.ProductComment1 && !values.ProductComment2 && !values.ProductComment3 && !values.ProductComment4 && !values.ProductComment5 && !values.ProductComment6)}
                    >
                      {formatMessage('apply')}
                    </Button>
                  </div>
                </Dropdown.Menu>
              </FormikForm>
            </Dropdown>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponent;
